import {useState} from 'react';

import {Button, Modal, TextArea} from '@/components';

type RejectLiveAccessModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (note: string) => void;
};

const RejectLiveAccessModal = ({
  isOpen,
  isLoading,
  onClose,
  onSubmit,
}: RejectLiveAccessModalProps) => {
  const [note, setNote] = useState('');
  const canSubmit = note.trim().length > 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Reject live access request"
      width="w-10/12 sm:w-10/12 md:w-7/12 lg:w-4/12"
      closeOnOutsideClick
      dataCy="live-access-reject-modal"
      footer={
        <div className="flex justify-end gap-3">
          <Button
            type="button"
            variant="ghost"
            colorScheme="cyan"
            dataCy="live-access-reject-cancel"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="button"
            colorScheme="red"
            onClick={() => canSubmit && onSubmit(note)}
            isLoading={isLoading}
            loadingText="Rejecting..."
            disabled={!canSubmit}
            dataCy="live-access-reject-submit"
          >
            Reject
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <TextArea
          label="Reason (shared with the business)"
          name="rejectNote"
          data-cy="live-access-reject-reason"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Explain why this request is being rejected"
        />
      </div>
    </Modal>
  );
};

export default RejectLiveAccessModal;
